/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './equipment-ip.reducer';

export const EquipmentIP = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const equipmentIPList = useAppSelector(state => state.equipmentIP.entities);
  const loading = useAppSelector(state => state.equipmentIP.loading);
  const totalItems = useAppSelector(state => state.equipmentIP.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="equipment-ip-heading" data-cy="EquipmentIPHeading">
        <Translate contentKey="tinyMedicRestApp.equipmentIP.home.title">Equipment IPS</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.equipmentIP.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/equipment-ip/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.equipmentIP.home.createLabel">Create new Equipment IP</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.equipmentIP.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {equipmentIPList && equipmentIPList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('charge')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.charge">Charge</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('charge')} />
                </th>
                <th className="hand" onClick={sort('chargeType')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.chargeType">Charge Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('chargeType')} />
                </th>
                <th className="hand" onClick={sort('allotted')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.allotted">Allotted</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('allotted')} />
                </th>
                <th className="hand" onClick={sort('supended')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.supended">Supended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('supended')} />
                </th>
                <th className="hand" onClick={sort('expiryDate')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.expiryDate">Expiry Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('expiryDate')} />
                </th>
                <th className="hand" onClick={sort('maxUses')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.maxUses">Max Uses</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('maxUses')} />
                </th>
                <th className="hand" onClick={sort('notes')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.notes">Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('notes')} />
                </th>
                <th className="hand" onClick={sort('deviceNo')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.deviceNo">Device No</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('deviceNo')} />
                </th>
                <th className="hand" onClick={sort('deviceName')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.deviceName">Device Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('deviceName')} />
                </th>
                <th className="hand" onClick={sort('mfdDate')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.mfdDate">Mfd Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('mfdDate')} />
                </th>
                <th className="hand" onClick={sort('dateSupended')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.dateSupended">Date Supended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dateSupended')} />
                </th>
                <th className="hand" onClick={sort('reasonSupended')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.reasonSupended">Reason Supended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('reasonSupended')} />
                </th>
                <th className="hand" onClick={sort('maintainanceCycle')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.maintainanceCycle">Maintainance Cycle</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('maintainanceCycle')} />
                </th>
                <th className="hand" onClick={sort('lastMaintenanceDate')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.lastMaintenanceDate">Last Maintenance Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastMaintenanceDate')} />
                </th>
                <th className="hand" onClick={sort('tax')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.tax">Tax</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tax')} />
                </th>
                <th className="hand" onClick={sort('underMaintainance')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.underMaintainance">Under Maintainance</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('underMaintainance')} />
                </th>
                <th className="hand" onClick={sort('equipmentType')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.equipmentType">Equipment Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('equipmentType')} />
                </th>
                <th className="hand" onClick={sort('location')}>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.location">Location</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('location')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.device">Device</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.hospital">Hospital</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.addedBy">Added By</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.equipmentIP.modifiedBy">Modified By</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {equipmentIPList.map((equipmentIP, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/equipment-ip/${equipmentIP.id}`} color="link" size="sm">
                      {equipmentIP.id}
                    </Button>
                  </td>
                  <td>{equipmentIP.microSec}</td>
                  <td>{equipmentIP.timestampentry}</td>
                  <td>{equipmentIP.lastupdated}</td>
                  <td>{equipmentIP.cursor}</td>
                  <td>{equipmentIP.active ? 'true' : 'false'}</td>
                  <td>{equipmentIP.charge}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ChargeType.${equipmentIP.chargeType}`} />
                  </td>
                  <td>{equipmentIP.allotted ? 'true' : 'false'}</td>
                  <td>{equipmentIP.supended ? 'true' : 'false'}</td>
                  <td>{equipmentIP.expiryDate}</td>
                  <td>{equipmentIP.maxUses}</td>
                  <td>{equipmentIP.notes}</td>
                  <td>{equipmentIP.deviceNo}</td>
                  <td>{equipmentIP.deviceName}</td>
                  <td>{equipmentIP.mfdDate}</td>
                  <td>{equipmentIP.dateSupended}</td>
                  <td>{equipmentIP.reasonSupended}</td>
                  <td>{equipmentIP.maintainanceCycle}</td>
                  <td>{equipmentIP.lastMaintenanceDate}</td>
                  <td>{equipmentIP.tax}</td>
                  <td>{equipmentIP.underMaintainance ? 'true' : 'false'}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.EquipmentType.${equipmentIP.equipmentType}`} />
                  </td>
                  <td>{equipmentIP.location}</td>
                  <td>{equipmentIP.device ? <Link to={`/device/${equipmentIP.device.id}`}>{equipmentIP.device.id}</Link> : ''}</td>
                  <td>{equipmentIP.hospital ? <Link to={`/hospital/${equipmentIP.hospital.id}`}>{equipmentIP.hospital.id}</Link> : ''}</td>
                  <td>
                    {equipmentIP.addedBy ? <Link to={`/hospital-manager/${equipmentIP.addedBy.id}`}>{equipmentIP.addedBy.id}</Link> : ''}
                  </td>
                  <td>
                    {equipmentIP.modifiedBy ? (
                      <Link to={`/hospital-manager/${equipmentIP.modifiedBy.id}`}>{equipmentIP.modifiedBy.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/equipment-ip/${equipmentIP.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/equipment-ip/${equipmentIP.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/equipment-ip/${equipmentIP.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.equipmentIP.home.notFound">No Equipment IPS found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={equipmentIPList && equipmentIPList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default EquipmentIP;
